import { render, staticRenderFns } from "./TournamentBasicInfo.vue?vue&type=template&id=376b9fee"
import script from "./TournamentBasicInfo.vue?vue&type=script&lang=js"
export * from "./TournamentBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./TournamentBasicInfo.vue?vue&type=style&index=0&id=376b9fee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports